.info-text-line-item {
  color: var(--color-grayscale-ghost);
  font-size: 1.4rem;
  font-weight: 400;
  text-transform: capitalize;
}

.blue-line {
  color: var(--color-primary-crayola);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.4px;
  margin-top: 0.8rem;
}

.description {
  padding-top: 0.8rem;
  font-family: Inter, sans-serif;
  line-height: 1.8rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  -webkit-box-orient: vertical;
  height: 6.2rem;
  color: var(--card-subtitle-color);

  &[data-is-default='true'] {
    color: var(--card-subtitle-color-low);
  }
}
